/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { cockpit_AbsenceRateMeasuresDTO } from './cockpit_AbsenceRateMeasuresDTO';
export type cockpit_AbsenceRateRowDTO = {
    absence_days?: number;
    absence_hours?: number;
    absence_rate_pct?: number | null;
    accident_cases?: number;
    accident_days?: number;
    accident_hours?: number;
    accident_nonwork_hours?: number;
    accident_rate_pct?: number | null;
    accident_unclassified_hours?: number;
    accident_work_hours?: number;
    avg_sick_case_days?: number | null;
    child_sick_days?: number;
    child_sick_hours?: number;
    childcare_id?: string | null;
    employee_count?: number;
    employment_percentage?: number | null;
    fte?: number;
    group_ids?: Array<string>;
    has_contract?: boolean;
    key?: string;
    kind?: cockpit_AbsenceRateRowDTO.kind;
    label?: string;
    other_days?: number;
    other_hours?: number;
    previous?: cockpit_AbsenceRateMeasuresDTO | null;
    role?: string | null;
    sick_cases?: number;
    sick_days?: number;
    sick_days_per_fte?: number | null;
    sick_hours?: number;
    sick_rate_pct?: number | null;
    target_hours?: number;
};
export namespace cockpit_AbsenceRateRowDTO {
    export enum kind {
        CHILDCARE = 'childcare',
        GROUP = 'group',
        EMPLOYEE = 'employee',
    }
}

